"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var Loader_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Loader"));
var TheSelectSimple_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/TheSelectSimple"));
var polished_1 = require("polished");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var CompetitionsApi_1 = tslib_1.__importDefault(require("../../../api/CompetitionsApi"));
var utilities_1 = require("../../../utilities/utilities");
var TeamMember_1 = tslib_1.__importDefault(require("./TeamMember"));
var utilitites_1 = require("./utilitites");
var YearSelectWrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  max-width: 200px;\n  margin-left: auto;\n  margin-right: auto;\n"], ["\n  max-width: 200px;\n  margin-left: auto;\n  margin-right: auto;\n"])));
var TeamMembersWrapper = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  display: grid;\n  grid-gap: 4px;\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n"], ["\n  display: grid;\n  grid-gap: 4px;\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n"])));
var LoaderWrapper = styled_components_1["default"].div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  margin-top: ", ";\n"], ["\n  display: flex;\n  justify-content: center;\n  margin-top: ", ";\n"])), polished_1.rem(16));
var ErrorWrapper = styled_components_1["default"].div(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  text-align: center;\n  color: red;\n  margin-top: ", ";\n"], ["\n  text-align: center;\n  color: red;\n  margin-top: ", ";\n"])), polished_1.rem(16));
var PositionHeader = styled_components_1["default"].h2(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject([""], [""])));
var WidgetSquad = function (_a) {
    var _b, _c, _d;
    var _e = _a.data, data = _e === void 0 ? {} : _e, renderEmpty = _a.renderEmpty;
    var teamId = data.teamId, year = data.year, appSpace = data.appSpace, withYearSelector = data.withYearSelector;
    var _f = react_1["default"].useState(false), isLoading = _f[0], setIsLoading = _f[1];
    var _g = react_1["default"].useState(null), playedYear = _g[0], setPlayedYear = _g[1];
    var _h = react_1["default"].useState([]), playedYearsOptions = _h[0], setPlayedYearsOptions = _h[1];
    // on first render, we have data from expadner so don't make requests
    var _j = react_1["default"].useState(false), shouldFetchSquadData = _j[0], setShouldFetchSquadData = _j[1];
    //
    var squadDataPositionLabels = react_1["default"].useState((_c = (_b = data.data) === null || _b === void 0 ? void 0 : _b.translations) !== null && _c !== void 0 ? _c : { crew: {} })[0];
    var _k = react_1["default"].useState(
    // reduce data from expander only when we have year in widget data, or when we are rendering
    // default played year (`defaultPlayedYear`) on initial render.
    (year || !shouldFetchSquadData) && data.appSpace
        ? utilitites_1.reduceExpandedData(data.appSpace, data.data, (_d = data.data) === null || _d === void 0 ? void 0 : _d.translations)
        : null), teamMembers = _k[0], setTeamMembers = _k[1];
    react_1["default"].useEffect(function () {
        (function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            var res, err_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(teamId && appSpace && !year)) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, CompetitionsApi_1["default"].getDistinctTeamPlayedYears(appSpace, teamId)];
                    case 2:
                        res = _a.sent();
                        setPlayedYearsOptions(res.data.map(function (y) { return ({ value: y.year, label: "" + y.year }); }));
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        alert('Nepodarilo sa získať zoznam ročníkov.');
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); })();
    }, [teamId, appSpace, year]);
    react_1["default"].useEffect(function () {
        (function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            var squadData, err_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(teamId && appSpace && playedYear && shouldFetchSquadData)) return [3 /*break*/, 5];
                        setIsLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, utilitites_1.getSquadData(appSpace, teamId, playedYear)];
                    case 2:
                        squadData = _a.sent();
                        setTeamMembers(utilitites_1.reduceExpandedData(appSpace, squadData, squadDataPositionLabels));
                        return [3 /*break*/, 5];
                    case 3:
                        err_2 = _a.sent();
                        alert("Nepodarilo sa z\u00EDska\u0165 zoznam hr\u00E1\u010Dov za rok " + playedYear + ".");
                        return [3 /*break*/, 5];
                    case 4:
                        setIsLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); })();
    }, [
        teamId,
        appSpace,
        playedYear,
        shouldFetchSquadData,
        squadDataPositionLabels,
    ]);
    var onChangePlayedYear = function (value) {
        setPlayedYear(value);
        setShouldFetchSquadData(true);
    };
    var getMemberKey = function (member, index) {
        return member.name + ":" + member.surname + ":" + member.position + ":" + member.nr + ":" + index;
    };
    var renderWidget = function () {
        return (react_1["default"].createElement(react_1["default"].Fragment, null,
            withYearSelector && (react_1["default"].createElement(YearSelectWrapper, { className: "content-widget-Squad-yearSelectorWrapper" },
                react_1["default"].createElement(TheSelectSimple_1["default"], { value: playedYear, onChange: onChangePlayedYear, options: playedYearsOptions, clearable: false }))),
            react_1["default"].createElement(react_1["default"].Fragment, null,
                isLoading ? (react_1["default"].createElement(LoaderWrapper, null,
                    react_1["default"].createElement(Loader_1["default"], { size: "l" }))) : (react_1["default"].createElement(react_1["default"].Fragment, null, teamMembers ? (react_1["default"].createElement(react_1["default"].Fragment, null,
                    teamMembers.goalkeepers &&
                        teamMembers.goalkeepers.length > 0 && (react_1["default"].createElement(react_1["default"].Fragment, null,
                        react_1["default"].createElement(PositionHeader, { className: "content-widget-Squad-positionHeader" }, utilities_1.__('Brankári')),
                        react_1["default"].createElement(TeamMembersWrapper, { className: "content-widget-Squad-teamMembersWrapper" }, teamMembers.goalkeepers.map(function (member, idx) { return (react_1["default"].createElement(TeamMember_1["default"], { member: member, key: getMemberKey(member, idx) })); })))),
                    teamMembers.players && teamMembers.players.length > 0 && (react_1["default"].createElement(react_1["default"].Fragment, null,
                        react_1["default"].createElement(PositionHeader, { className: "content-widget-Squad-positionHeader" }, utilities_1.__('Hráči')),
                        react_1["default"].createElement(TeamMembersWrapper, { className: "content-widget-Squad-teamMembersWrapper" }, teamMembers.players.map(function (member, idx) { return (react_1["default"].createElement(TeamMember_1["default"], { member: member, key: getMemberKey(member, idx) })); })))),
                    teamMembers.coaches && teamMembers.coaches.length > 0 && (react_1["default"].createElement(react_1["default"].Fragment, null,
                        react_1["default"].createElement(PositionHeader, { className: "content-widget-Squad-positionHeader" }, utilities_1.__('Tréneri')),
                        react_1["default"].createElement(TeamMembersWrapper, { className: "content-widget-Squad-teamMembersWrapper" }, teamMembers.coaches.map(function (member, idx) { return (react_1["default"].createElement(TeamMember_1["default"], { member: member, key: getMemberKey(member, idx) })); })))),
                    teamMembers.crew && teamMembers.crew.length > 0 && (react_1["default"].createElement(react_1["default"].Fragment, null,
                        react_1["default"].createElement(PositionHeader, { className: "content-widget-Squad-positionHeader" }, utilities_1.__('Realizačný tím')),
                        react_1["default"].createElement(TeamMembersWrapper, { className: "content-widget-Squad-teamMembersWrapper" }, teamMembers.crew.map(function (member, idx) { return (react_1["default"].createElement(TeamMember_1["default"], { member: member, key: getMemberKey(member, idx) })); })))))) : (react_1["default"].createElement(ErrorWrapper, null, utilities_1.__('Pre zvolené obdobie neboli nájdené žiadne záznamy.'))))),
                ' ')));
    };
    if (data.appSpace &&
        data.teamId &&
        data.data &&
        data.data.athletes &&
        data.data.athletes.length > 0) {
        return renderWidget();
    }
    else {
        return renderEmpty ? renderEmpty('squad') : null;
    }
};
exports["default"] = WidgetSquad;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
